import { ReactNode } from 'react'
import { Tooltip, Typography, useTheme } from '@mui/material'
import { useStyles } from './styles'

interface ItemWithPopoverProps {
  item: ReactNode
  title?: string
  subtitle?: ReactNode | null
  locationName?: string
  popoverContent?: ReactNode
  cursor?: string
}

const ItemWithPopover = ({
  item,
  title,
  subtitle,
  locationName,
  popoverContent,
  cursor = 'default',
}: ItemWithPopoverProps) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            mt: '4px !important',
            bgcolor: theme.palette.custom.white,
            boxShadow: theme.shadows[5],
            color: theme.palette.custom.darkBlue2,
            p: '4px',
            pl: '8px',
          },
        },
      }}
      title={
        <div>
          {popoverContent && popoverContent}
          {title && <Typography className={classes.title}>{title}</Typography>}
          {locationName && <Typography className={classes.locationName}>{locationName}</Typography>}
          {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
        </div>
      }
      enterDelay={50} // Optional: Adjust tooltip delay as needed
    >
      <div style={{ cursor: cursor }}>{item}</div>
    </Tooltip>
  )
}

export { ItemWithPopover }
